import React from 'react';
import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import { Grid, Form, Button } from 'semantic-ui-react';

import { Column } from 'components/Layout';
import ProfilointernoService from 'shared/services/api/internokiron/profilo';

import { AddableSelect } from '../../UI/AddableSelect';
import DividerForm from '../../UI/DividerForm';

export class InternoKironForm extends React.Component {

  state = {
    profili: [],
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    ProfilointernoService
      .getAllOptions()
      .then((res) => {
        this.setState({
          profili: res.options, // eslint-disable-line
        });
      });
  }

  render() {
    return (
      <Form autoComplete="off" onSubmit={this.props.handleSubmit} loading={this.props.isSubmitting}>
        <Grid>
          <Column width={16}>
            <AddableSelect {...this.props} required options={this.state.profili} elements={this.props.values.profili} type="profili" label="Profili associati" onChange={this.props.setFieldValue} />
          </Column>
          <DividerForm />
          <Column width={8}>
            <Button onClick={this.props.closeModal} type="button" icon="delete" labelPosition="right" content="Chiudi" />
          </Column>
          <Column width={8} textAlign="right">
            <Button loading={this.props.isSubmitting} type="submit" icon="save" labelPosition="left" positive disabled={this.props.isSubmitting} content="Salva" />
          </Column>
        </Grid>
      </Form>);
  }

}

export default InternoKironForm;

InternoKironForm.propTypes = {
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  // touched: PropTypes.object,
  // errors: PropTypes.object,
  // setFieldTouched: PropTypes.func,
  handleSubmit: PropTypes.func,
  closeModal: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/InternoKiron/Form.js